import { createElement, FC, useContext, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';

import { context as DependencyContext } from '../context/dependency';
import Page from '../page/ProjectTypesListPage';

type Props = RouteComponentProps;

const ProjectTypesListPage: FC<Props> = () => {
  const dependency = useContext(DependencyContext);

  useEffect(() => {
    dependency.authenticationUsecase.needSignedIn();
    dependency.listProjectTypesUsecase.prepare().then(() => {});

    return () => {
      dependency.listProjectTypesUsecase.dispose();
    };
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Page />;
};

export default ProjectTypesListPage;
